export default __webpack_public_path__ + "static/Why Listening and Reading-000cffc69286935c122a99ca955fe53f.jpg";